export const CHANGE_VALUE_INPUT = "CHANGE_VALUE_INPUT";
export const GET_INPUT_VALUE = "GET_INPUT_VALUE";
export const IS_DISABLE = "IS_DISABLE";

export const REVERSE_VALUE_INPUTS = "REVERSE_VALUE_INPUTS";